//
//
//
//
//
//
//
//
//
//

import { getEnvEducationDetail } from '@/common/js/api.js'

export default {
  methods: {
    getEnvEducationDetail(envEducationId) {
      let self = this
      console.log(envEducationId)
      getEnvEducationDetail({ data: { newsId: envEducationId } }).then(function(data) {
        self.entity = data.Content
        document.title = self.entity.title
      })
    }
  },
  data() {
    return {
      entity: {}
    }
  },
  created() {
    let envEducationId = this.$route.query.envEducationId
    this.getEnvEducationDetail(envEducationId)
  }
}



// WEBPACK FOOTER //
// ./src/components/envEducation/Detail.vue